import React, { useState, useEffect } from "react";
// import Select from "react-select";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import assocService from "../../services/assoc.service";
import authService from "../../services/auth.service";

import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
// import "./ModalCheckMember.css";

// Import Form
import { Form, Col, Row, FormControl } from "react-bootstrap";

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

function ModalCheckMember(props) {
  const [form, setForm] = useState({});
  const [data, setData] = useState([]);
  // const [assoc, setAssoc] = useState([]);
  const [errors, setErrors] = useState({});
  const [check, setCheck] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disabledbutton, setDisabledbutton] = useState(true);

  const user = authService.getCurrentUser();

  useEffect(() => {
    getData();
    initialForm();
  }, []);

  const initialForm = () => {
    // getData();
    setForm({});
    setCheck([]);
    setErrors({});
  };

  const handleClose = () => {
    getData();
    initialForm();
    setForm({});
    setCheck([]);
    props.hidefunc(false);
  };

  const getData = () => {
    assocService
      .getAssocList()
      .then((response) => {
        setData(response.data.data);
        // console.log(props);
        // if (Object.keys(props.assocdata).length !== 0) {
        //   setForm({ ...form, ["assoc"]: props.assocdata });
        // } else {
        //   setForm({ ...form, ["assoc"]: data });
        // }
        setErrors({
          ...errors,
          ["assoc"]: null,
        });
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setErrors(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const checkID = (id) => {
    // console.log(id.length);
    if (id.length != 13) return false;
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseFloat(id.charAt(i)) * (13 - i);
    }
    if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) return false;

    return true;
  };

  // const getAssoc = () => {
  //   if (props.assocdata === null) {
  //     const assoc_id = form.assoc.associd;
  //     assocService.getAssociationById(assoc_id).then((response) => {
  //       console.log(form.assoc.associd);
  //       setAssoc(response.data.data);
  //       // setAssocName(assoc.association_name_th);
  //     });
  //   }
  // };

  const setField = (field, value) => {
    setCheck([]);
    setDisabledbutton(true);
    if (field.name == "search") {
      // console.log(!checkID(value));
      if (value.length < 13) {
        setErrors({ ...errors, [field.name]: "กรอกเลขไม่ครบ" });
      } else if (value.length > 13) {
        setErrors({ ...errors, [field.name]: "กรอกเลขเกิน" });
      } else if (!checkID(value)) {
        setErrors({ ...errors, [field.name]: "เลขบัตรไม่ถูกต้อง" });
      } else {
        setErrors({ ...errors, [field.name]: null });
      }
    }
    setForm({
      ...form,
      [field.name]: value,
    });
    // props.assocdata([{...form.assoc}]);
    // console.log(props.assocdata);
  };
  const findFormErrors = () => {
    const { search, assoc } = form;
    const newErrors = {};

    if (user.user.member_type !== 4) {
      // start errors
      if (!assoc || assoc === "") newErrors.assoc = "กรุณาระบุสมาคม";
    }
    if (!search || search === "") newErrors.search = "กรุณากรอกเลขบัตรประชาชน";

    return newErrors;
  };

  // const handleAddMember = (object) => {
  //   const search = { search: object[0].farmer_idcard };
  //   setForm(search);
  //   RegsugarService.checkFarmer(search)
  //     .then((response) => {
  //       // console.log(response.data.data);
  //       if (response.data.success) {
  //         checkStatusForMember(response.data.data);
  //         setCheck(response.data.data);
  //       }
  //     })
  //     .catch((error) => {
  //       alert(error);
  //       console.log(error);
  //     })
  //     .finally(() => {
  //       console.log(false);
  //       setLoading(false);
  //     });
  // };

  // const handleAssocChange = async (assoc) => {
  //   setErrors({
  //     ...errors,
  //     ["assoc"]: null,
  //   });
  //   if (assoc && assoc != "") {
  //     await getData(assoc).then(() => {
  //       setForm({
  //         ...form,
  //         ["assoc"]: assoc,
  //       });
  //     });
  //   } else {
  //     setData([]);
  //   }
  // };

  const clickAddMember = (e) => {
    e.preventDefault();
    props.onClickAdd(form);
    setForm({});
    setCheck([]);
    // props.getAssoc(form.assoc);
    // console.log(newform);
  };

  const clickNewFarmer = () => {
    // e.preventDefault();
    const newform = [{ ...form }];
    props.onClickNew(newform);
    // props.getAssoc(form.assoc);
    console.log(newform);
  };

  const getValidMember = (idcard, select_assoc) => {
    assocService
      .validateNewMember(idcard, select_assoc)
      .then((response) => {
        console.log(response.data.data);
        if (response.data.success) {
          checkStatusForMember(response.data.data);
          if (response.data.data.length != 0) {
            setCheck(response.data.data);
          } else {
            confirmAlert({
              title: "",
              message: "ไม่มีข้อมูลเกษตรกรในระบบ ต้องการเพิ่มข้อมูลหรือไม่",
              buttons: [
                {
                  label: "ใช่",
                  onClick: () => {
                    // window.location.href = config.hostname + "/staff/farmer";
                    props.hidefunc(true);
                    clickNewFarmer();
                  },
                },
                {
                  label: "ไม่ใช่",
                  onClick: () => false,
                },
              ],
              overlayClassName: "confirm-alert-default",
            });
          }
        } else {
          alert(response.data.message);
        }
      })
      .catch((error) => {
        alert(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCheck = (e) => {
    e.preventDefault();
    setLoading(true);
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setLoading(false);
    } else {
      const form_assoc =
        Object.keys(props.assocdata).length !== 0
          ? props.assocdata.association_id
          : form.assoc;
      console.log(form_assoc);
      if (user.user.member_type !== 4) {
        getValidMember(form.search, form_assoc);
      } else {
        getValidMember(form.search, user.user.user_assoc);
      }
    }
  };

  const checkStatusForMember = (data) => {
    if (data.length != 0) {
      const result = data.filter(
        (a) =>
          a.assoc_status_text === "เป็นสมาชิก" ||
          a.farmer_status === "เสียชีวิต" ||
          a.reg_status_text === "พ้นสภาพ"
      );
      setDisabledbutton(result.length > 0 ? true : false);
    } else {
      setDisabledbutton(true);
    }
  };

  const statusFormatter = (cell) => {
    console.log(cell);
    if (
      cell == "เป็นสมาชิก" ||
      cell == "ชาวไร่" ||
      cell == "มีชีวิต" ||
      cell == "ส่งปกติ"
    ) {
      return <p className="text-success">{cell}</p>;
    } else if (cell == "พ้นสภาพ" || cell == "ขาดส่ง") {
      return <p className="text-warning">{cell}</p>;
    } else if (
      cell == "ลาออก" ||
      cell == "เสียชีวิต" ||
      cell == "ไม่มีการส่ง"
    ) {
      return <p className="text-danger">{cell}</p>;
    } else {
      return <p>{cell}</p>;
    }
  };

  const memberFormatter = (cell) => {
    console.log(cell);
    if (cell == "เป็นสมาชิก") {
      return <p className="text-success">{cell}</p>;
    } else if (cell == "พ้นสภาพ") {
      // return <p className="text-warning">{cell}</p>;
      return (
        <div>
          <p className="text-warning">{cell}</p>
          <button
            disabled={disabledbutton}
            className="btn btn-warning btn-disable-custom"
            onClick={clickAddMember}
          >
            ลงทะเบียนใหม่
          </button>
        </div>
      );
    } else if (cell == "ลาออก") {
      return (
        <div>
          <p className="text-danger">{cell}</p>
          <button
            disabled={disabledbutton}
            className="btn btn-danger btn-disable-custom"
            onClick={clickAddMember}
          >
            ลงทะเบียนใหม่
          </button>
        </div>
      );
    } else {
      return (
        <button
          disabled={disabledbutton}
          className="btn btn-success btn-disable-custom"
          onClick={clickAddMember}
        >
          เพิ่มสมาชิก
        </button>
      );
    }
  };
  const columns = [
    {
      dataField: "farmer_idcard",
      text: "ID",
      hidden: true,
    },
    {
      dataField: "farmer_idcard",
      text: "บัตรประชาชน",
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        textAlign: "center",
      },
    },
    {
      dataField: "farmer_name",
      text: "ชื่อ - สกุล",
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        textAlign: "center",
      },
    },
    {
      dataField: "farmer_card_id",
      text: "รหัสเกษตรกร",
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        textAlign: "center",
      },
    },
    {
      dataField: "reg_status_text",
      text: "ข้อมูลชาวไร่อ้อย",
      formatter: statusFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        textAlign: "center",
      },
    },
    {
      dataField: "farmer_status",
      text: "สถานะ",
      formatter: statusFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        textAlign: "center",
      },
    },
    {
      dataField: "assoc_status_text",
      text: "การเป็นสมาชิก",
      formatter: memberFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        textAlign: "center",
      },
    },
  ];

  return (
    <>
      {loading ? <LoadingAlert /> : ""}
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>ตรวจสอบข้อมูล</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {/* {user.user.user_assoc ? user.user.user_assoc : form.assoc} */}
            {/* {Object.keys(props.assocdata).length} */}
            <Form>
              <Row className="search-check">
                {user.user.member_type !== 4 ? (
                  <Col>
                    <Form.Group>
                      <Form.Select
                        name="assoc"
                        // value={
                        //   props.assocdata.association_id !== 0
                        //     ? props.assocdata.association_id
                        //     : form.assoc
                        // }
                        value={form.assoc}
                        // onChange={(e) => handleAssocChange(e.target.value)}
                        onChange={(e) => setField(e.target, e.target.value)}
                        isInvalid={!!errors.assoc}
                        // disabled={
                        //   Object.keys(props.assocdata).length === 0
                        //     ? false
                        //     : true
                        // }
                      >
                        <option key={0} value="">
                          เลือกสมาคม
                        </option>
                        {data.map((j) => {
                          return (
                            <option key={j.index} value={j.associd}>
                              {j.assocname}
                            </option>
                          );
                        })}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.assoc}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                ) : (
                  ""
                )}
                <Col>
                  <Form.Group>
                    <FormControl
                      placeholder="บัตรประชาชน"
                      type="number"
                      name="search"
                      value={form.search}
                      onChange={(e) => setField(e.target, e.target.value)}
                      isInvalid={!!errors.search}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.search}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg="4">
                  <Form.Group>
                    <button
                      className="btn btn-primary btn-add-custom"
                      onClick={handleCheck}
                    >
                      ตรวจสอบการเป็นสมาชิก
                    </button>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </div>
          <div className="list-regsugar-name" lg="12">
            <BootstrapTable
              keyField="farmer_id"
              data={check}
              columns={columns}
              // width="100%"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <button className="btn btn-warning" onClick={handleClose}>
            Close
          </button>
          <button
            className="btn btn-primary"
            type="submit"
            onClick={handleSubmit}
          >
            Save Changes
          </button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalCheckMember;

ModalCheckMember.propTypes = {
  show: PropTypes.bool,
  hidefunc: PropTypes.func,
  onClickAdd: PropTypes.func,
  onClickNew: PropTypes.func,
  assocdata: PropTypes.object,
};
